<template>
    <div class="rd">
        <div class="pagina">
            <header class="paginakop">
                <div class="tekst">
                    <h1>Applications</h1>
                    <p>The apps that run on X-Corp devices. Open an app to manage which version runs on each device.</p>
                </div>
            </header>

            <p v-if="loading" class="rd-laden">Loading applications...</p>

            <section v-else class="paneel">
                <div class="paneel-kop" style="flex-wrap: wrap">
                    <h2>Applications</h2>
                    <div class="snel rechts">
                        <button
                            v-for="t in typeFilters"
                            :key="t.value"
                            class="chip"
                            type="button"
                            :aria-pressed="activeType === t.value"
                            @click="activeType = t.value"
                        >{{ t.label }}</button>
                    </div>
                </div>

                <div v-if="filteredApps.length" class="tabel-wikkel">
                    <table class="tabel">
                        <thead>
                            <tr><th>Name</th><th>For</th><th><span hidden>Open</span></th></tr>
                        </thead>
                        <tbody>
                            <tr v-for="app in filteredApps" :key="app.id" class="klikbaar" @click="openApplication(app)">
                                <td><span class="num">{{ app.repository }}</span></td>
                                <td>
                                    <span class="tags">
                                        <span v-for="t in appTypes(app)" :key="t" class="tag-type">{{ t.toUpperCase() }}</span>
                                    </span>
                                </td>
                                <td class="rechts">
                                    <button class="btn btn-stil btn-sm" type="button" @click.stop="openApplication(app)">Manage</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else class="leeg">
                    <h2>No application for this device type</h2>
                    <p>Choose another device type or All types.</p>
                </div>
            </section>
        </div>
    </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router/composables";
import { getApplications } from "../../api/graphql/applications";

const router = useRouter();
const apps = ref([]);
const loading = ref(false);
const activeType = ref("");

const typeFilters = [
    { value: "", label: "All types" },
    { value: "xcube", label: "XCube" },
    { value: "xpod", label: "XPod" },
    { value: "xkiosk", label: "XKiosk" },
    { value: "xtend", label: "XTend" },
];

const appTypes = (app) =>
    ["xcube", "xpod", "xkiosk", "xtend"].filter((t) => app[`type_for_${t}`] || app.flexible);

const filteredApps = computed(() =>
    apps.value
        .filter((a) => !activeType.value || appTypes(a).includes(activeType.value))
        .slice()
        .sort((a, b) => (a.repository || "").localeCompare(b.repository || "")),
);

const openApplication = (app) => {
    router.push({ name: "application", params: { id: app.id } });
};

onMounted(async () => {
    loading.value = true;
    apps.value = await getApplications();
    loading.value = false;
});
</script>
